import React from 'react';
import isEmpty from 'lodash/isEmpty';
import {
    FormControl,
    InputBase,
    FormHelperText,
    Typography
} from '@mui/material';


function FormInputDatePicker(props) {
    let {
        label = '',
        path,
        index,
        value = '',
        error = '',
        readOnly = false,
        onChange,
        onBlur,
        fullWidth,
        validator,
        min = -99999,
        mask = '',
        refProp,
        style = {},
        InputProps = {}
    } = props;

    const hasError = !isEmpty(error);

    let extraProps = {};
    if (min !== -99999)
        extraProps = {
            min
        };
    
    let attributes = {
        error: hasError
    };

    return (
        <React.Fragment>
            <FormControl style={style} fullWidth={fullWidth} sx={{ marginTop: 2 }} variant="outlined">
                <Typography>{label}</Typography>
                { !mask && 
                  <InputBase
                      fullWidth={fullWidth}
                      value={value}
                      onChange={(event)=>{
                          if (readOnly) return;
                          if (!onChange) return;

                          onChange({value: event.target.value, name: path, index});
                      }
                      }
                      onBlur={event => onBlur && onBlur(event.target.value, path, validator)}
                      {...extraProps}
                      ref={refProp}
                      type={'date'}
                      label={label}
                      {...attributes}
                      variant='standard'
                      inputProps={InputProps}
                  />

                }

                {hasError && <FormHelperText id="outlined-error-helper-text">{error}</FormHelperText>}
            </FormControl>
        </React.Fragment>
    );
}

export default FormInputDatePicker;
